import { render, staticRenderFns } from "./DefaultDialog.vue?vue&type=template&id=4cc3df52&scoped=true"
import script from "./DefaultDialog.vue?vue&type=script&lang=js"
export * from "./DefaultDialog.vue?vue&type=script&lang=js"
import style0 from "./DefaultDialog.vue?vue&type=style&index=0&id=4cc3df52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc3df52",
  null
  
)

export default component.exports